import { useContext, useEffect, useState } from "react";
import undrawProfile from "../img/undraw_profile.svg";
import { AppContext } from "../contexts/AppContext";
import VideoPlayer from "../components/VideoPlayer";
import { useDispatch, useSelector } from "react-redux";
import { getReels } from "../store/actions/userActions";
import NoDataAvailable from "../components/NoDataAvailable";
import axiosHttp from "../config/axios.interceptor";
import { getActiveNotificationCount } from "../store/actions/notificationAction";
import { getActiveChatNotificationCount } from "../store/actions/chatNotificationAction";
import Loader from "../components/Loader";
import useClickOutside from "../Hooks/UseClickOutside";
import { AuthContext } from "../contexts/AuthContext";
import {
  calculateReturnStatement,
  concatenateAndTruncate,
  truncateText,
} from "../../utils/application-helper";
import { Link, useNavigate } from "react-router-dom";
import { errorResponseMessage } from "../shared/const.prop";
import bookmark from "../img/bookmark.png";
import bookFilled from "../img/save.png";
import retweet from "../img/retweet.png";

const ReelsVideoWrapper = ({
  reelsData,
  likeHander,
  bookHandler,
  retweetHandler,
}) => {
  const appContext = useContext(AppContext);
  const authContext = useContext(AuthContext);
  const [isOpen, toggle, containerRef] = useClickOutside(false);
  const { userData } = useSelector((state) => state.user);
  const navigate = useNavigate();
  const playListener = (reelId) => appContext.updateCurrentPlayerId(reelId);
  const stopListener = (reelId) => {
    if (appContext.currentPlayerId === reelId)
      appContext.updateCurrentPlayerId(null);
  };
  const { user } = authContext;

  useEffect(() => {
    appContext.updateCurrentPlayerId(null);
  }, []);

  const reportPostHandler = (post) => {
    appContext.updateModalType("reportPost", "Report Reel", post);
  };

  const [isTruncated, setIsTruncated] = useState(true);

  const toggleTruncate = () => {
    setIsTruncated(!isTruncated);
  };

  const truncatedText = reelsData?.description
    ? truncateText(reelsData?.description, 100)
    : null;

  const userId = user?.userId || user?.data?.data?.userId;

  return (
    <div className="row mt-20">
      <div className="col-md-1"></div>
      <div className="col-md-10">
        <div className="app-video">
          <div className="video">
            <div className="videoFooter">
              <div className="vfooter-content">
                <div className="vfooter-text mb-3">
                  {reelsData?.isSharedPost && (
                    <div
                      className="repost-row"
                      onClick={() => navigate(`../${post?.sharedPostUsername}`)}
                    >
                      <img
                        src={reelsData?.sharedPostPic || undrawProfile}
                        alt="profile"
                      />
                      <h6>
                        <span>{reelsData?.sharedPostName}</span> reposted this
                      </h6>
                    </div>
                  )}
                  <Link to={`../${reelsData?.user_name}`} className="d-flex">
                    <div className="sme-profile">
                      <img
                        className={`img-profile rounded-circle mr-2 ${
                          reelsData?.offerService ? "sme-mini-service" : null
                        }`}
                        src={reelsData?.pic_url || undrawProfile}
                      />
                      {reelsData?.offerService && (
                        <div className="sme-mini-icon">SME</div>
                      )}
                    </div>
                    <div>
                      <p className="user-name mb-0 user ml-1">
                        {reelsData.userName}
                      </p>
                      <p className="user-des mb-0 ml-1">
                        {reelsData?.experties &&
                          reelsData?.experties.length > 0 &&
                          concatenateAndTruncate(
                            reelsData?.experties,
                            30,
                            "value"
                          )}
                        <span className="post-hour">
                          {calculateReturnStatement(
                            new Date(reelsData?.created_at).getTime()
                          )}
                        </span>
                      </p>
                    </div>
                  </Link>

                  {false && reelsData.userId !== userData.userId && (
                    <button
                      type="button"
                      className="btn btn-outline-primary reel-btn px-2"
                    >
                      Follow
                    </button>
                  )}
                </div>
                <div className="vfooter-desc">
                  {reelsData?.description && (
                    <p
                      dangerouslySetInnerHTML={{
                        __html: isTruncated
                          ? truncatedText
                          : reelsData?.description,
                      }}
                    />
                  )}
                  {reelsData?.description &&
                    reelsData?.description.length > 100 && (
                      <span
                        onClick={toggleTruncate}
                        style={{ color: "blue", cursor: "pointer" }}
                      >
                        {isTruncated ? "Read More" : "Read Less"}
                      </span>
                    )}
                </div>
              </div>
            </div>
            <VideoPlayer
              classProp="video-player"
              id={reelsData.id}
              wrapper={{
                width: "100%",
                height: "500px",
                overflow: "hidden",
              }}
              videoSrc={reelsData.url}
              playListener={() => playListener(reelsData.id)}
              stopListener={() => stopListener()}
            />
            <div
              className="d-flex align-items-center justify-content-between w-100 mt-3 pos-relative"
              ref={containerRef}
            >
              <div>
                <span
                  className="cursor-pointer ml-1"
                  onClick={() => likeHander(reelsData.id)}
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    fill="none"
                  >
                    <g clipPath="url(#clip0_305_71)">
                      <path
                        d="M22.368 11.394V19.9824H18.732L18.5484 20.004C15.1728 20.7912 12.936 21.3588 11.8212 21.7104C10.3404 22.1772 9.78839 22.2912 8.78399 22.3584C8.03279 22.41 7.17959 22.1208 6.79079 21.7248C6.57599 21.5064 6.41519 21.0576 6.35159 20.3616C6.33841 20.2157 6.28624 20.076 6.20052 19.9571C6.11481 19.8382 5.99871 19.7446 5.86439 19.686C5.56559 19.5564 5.31719 19.3452 5.10959 19.038C4.91759 18.7572 4.79279 18.234 4.76999 17.4768C4.76598 17.3376 4.72651 17.2017 4.65533 17.082C4.58414 16.9624 4.48359 16.8628 4.36319 16.7928C3.66479 16.3884 3.31919 15.9324 3.24718 15.3972C3.16799 14.8056 3.35999 14.1396 3.86279 13.3812C3.98076 13.2034 4.02469 12.9865 3.98525 12.7767C3.94581 12.567 3.82611 12.3809 3.65158 12.258C3.17039 11.9196 2.90639 11.4492 2.84039 10.782C2.73479 9.71882 3.41279 8.93282 4.94759 8.77562C6.31454 8.64042 7.6947 8.75551 9.02039 9.11522C9.17077 9.15452 9.32925 9.15005 9.47718 9.10234C9.6251 9.05463 9.75633 8.96567 9.85541 8.84591C9.9545 8.72615 10.0173 8.58059 10.0365 8.42634C10.0556 8.27209 10.0304 8.11558 9.96359 7.97522C9.36359 6.70562 9.02999 5.65802 8.95199 4.84682C8.84999 3.77042 9.09839 2.99042 9.67919 2.34722C10.1196 1.86002 10.824 1.58162 11.088 1.63922C11.436 1.71362 11.6628 1.91522 11.958 2.62082C12.132 3.03842 12.216 3.39362 12.36 4.22282C12.498 5.01002 12.5736 5.36522 12.7308 5.83082C13.2048 7.24202 14.3676 8.70482 15.9288 9.71402C17.023 10.4205 18.2088 10.9736 19.4532 11.358C19.5309 11.382 19.6118 11.3941 19.6932 11.394H22.368ZM22.4184 21.618C22.806 21.6288 23.154 21.5424 23.4456 21.3384C23.8176 21.078 23.9928 20.6676 23.9964 20.1948L23.9928 11.4072C24.0336 10.9392 23.8956 10.5096 23.5692 10.1904C23.2632 9.89042 22.8636 9.74882 22.4412 9.75842H19.8192C18.7586 9.42047 17.7474 8.94352 16.812 8.34002C15.5544 7.52642 14.628 6.36002 14.274 5.30882C14.1528 4.94642 14.088 4.64642 13.9656 3.94082C13.8 2.99402 13.6968 2.55362 13.4592 1.98722C12.9672 0.808822 12.3216 0.232822 11.4312 0.0396221C10.5552 -0.149978 9.27959 0.355222 8.47319 1.24802C7.57919 2.23682 7.18439 3.47402 7.33079 5.00282C7.39319 5.66042 7.57559 6.39602 7.87559 7.21562C6.85106 7.06631 5.81204 7.04374 4.78199 7.14842C2.37359 7.39442 1.02118 8.96282 1.21799 10.9452C1.30439 11.7996 1.61399 12.5256 2.14079 13.0956C1.69799 13.9488 1.52159 14.7924 1.63199 15.6156C1.75919 16.5636 2.28719 17.3532 3.16559 17.9664C3.23399 18.798 3.42479 19.4616 3.76319 19.9584C4.02983 20.3598 4.37772 20.7007 4.78439 20.9592C4.91399 21.78 5.18639 22.422 5.63159 22.8732C6.36959 23.6244 7.68839 24.072 8.89319 23.9904C10.0368 23.9136 10.7136 23.7744 12.3096 23.2704C13.362 22.938 15.5412 22.386 18.8256 21.618H22.4196H22.4184ZM20.3772 11.0208C20.3775 10.9135 20.3566 10.8071 20.3158 10.7078C20.2749 10.6085 20.2148 10.5183 20.139 10.4423C20.0632 10.3662 19.9732 10.3059 19.874 10.2648C19.7749 10.2236 19.6685 10.2024 19.5612 10.2024C19.454 10.2027 19.348 10.2242 19.2491 10.2655C19.1502 10.3068 19.0604 10.3671 18.9849 10.4431C18.9093 10.5191 18.8495 10.6092 18.8088 10.7084C18.7681 10.8075 18.7473 10.9137 18.7476 11.0208V20.2344C18.7474 20.3416 18.7684 20.4477 18.8092 20.5468C18.8501 20.6458 18.9101 20.7359 18.9857 20.8118C19.0614 20.8877 19.1513 20.9479 19.2502 20.989C19.3492 21.0302 19.4552 21.0515 19.5624 21.0516C19.6695 21.0515 19.7756 21.0302 19.8746 20.989C19.9735 20.9479 20.0634 20.8877 20.139 20.8118C20.2147 20.7359 20.2747 20.6458 20.3155 20.5468C20.3564 20.4477 20.3773 20.3416 20.3772 20.2344V11.0208Z"
                        fill={
                          reelsData?.likeStatus === "Like"
                            ? "rgb(48, 50, 146)"
                            : "black"
                        }
                      />
                    </g>
                    <defs>
                      <clipPath id="clip0_305_71">
                        <rect
                          width="24"
                          height="24"
                          fill="white"
                          transform="matrix(-1 0 0 1 24 0)"
                        />
                      </clipPath>
                    </defs>
                  </svg>
                </span>
                <span className="mr-3 mt-2 ml-2" style={{ fontSize: "12px" }}>
                  {reelsData.postLikeCount || null}
                </span>
                <span
                  className="book-mark"
                  onClick={() => bookHandler(reelsData?.id)}
                >
                  <img
                    src={
                      reelsData?.isBookmark === "Yes" ? bookFilled : bookmark
                    }
                    alt="bookmark"
                  />
                </span>
                <span
                  className="book-mark"
                  onClick={() => retweetHandler(reelsData?.id)}
                >
                  <img src={retweet} alt="bookmark" />
                </span>
              </div>

              {isOpen && (
                <div className="schedule-options reel-drop">
                  {" "}
                  <span
                    className="dropdown-item cursor-pointer mt-1"
                    // onClick={() =>
                    //   appContext.updateModalType(
                    //     "reportPost",
                    //     "Report Post",
                    //     post
                    //   )
                    // }
                    onClick={() => reportPostHandler(reelsData)}
                  >
                    Report
                  </span>
                </div>
              )}
              {reelsData?.isAdminBlocked === false &&
                userId !== reelsData?.userId && (
                  <div className="dropdown  mb-3 mr-3" onClick={toggle}>
                    <span className="cursor-pointer">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="4"
                        height="17"
                        viewBox="0 0 4 17"
                        fill="none"
                      >
                        <circle cx="2" cy="2" r="2" fill="#000" />
                        <circle cx="2" cy="8" r="2" fill="#000" />
                        <circle cx="2" cy="15" r="2" fill="#000" />
                      </svg>
                    </span>
                  </div>
                )}
            </div>
          </div>
        </div>
      </div>
      <div className="col-md-1"></div>
    </div>
  );
};

const Reels = () => {
  const appContext = useContext(AppContext);
  const authContext = useContext(AuthContext);
  const dispatch = useDispatch();
  const { reels } = useSelector((state) => state.user);
  const [reelsCollection, setReelsColletion] = useState([]);
  const [initialLoad, setInitialLoad] = useState(false);
  const [page, setPage] = useState(1);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (appContext.openModal === false) {
      setLoading(true);
      fetchReels(1);
      setPage(1);
      setInitialLoad(true);
    } else {
      fetchReels(page);
      setInitialLoad(true);
    }
  }, [appContext.openModal, appContext.category]);

  useEffect(() => {
    let debounceTimeout;

    const handleScroll = () => {
      clearTimeout(debounceTimeout);

      debounceTimeout = setTimeout(() => {
        const scrollY = window.scrollY;
        const viewportHeight = window.innerHeight;
        const pageHeight = document.documentElement.scrollHeight;

        const scrollThreshold = 0.8;

        const distanceFromBottom = pageHeight - (scrollY + viewportHeight);

        if (
          distanceFromBottom / pageHeight <= 1 - scrollThreshold &&
          !loading &&
          initialLoad
        ) {
          fetchReels(page);
        }
      }, 200);
    };

    window.addEventListener("scroll", handleScroll);

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, [page, loading, initialLoad]);

  const likeHander = async (reelId) => {
    // console.log(reelId);
    try {
      const reelsLikeResponse = await axiosHttp.post(`post/${reelId}/like`);
      if (reelsLikeResponse.status === 201) {
        const updatedReelsCollection = reelsCollection.map((reel) => {
          console.log(reel.likeStatus);
          if (reel.id === reelId) {
            // console.log("modified");
            reel.likeStatus = reel.likeStatus === "Like" ? "DisLike" : "Like";
            reel.postLikeCount =
              reel.likeStatus === "Like"
                ? reel.postLikeCount + 1
                : reel.postLikeCount - 1;
          }
          return reel;
        });
        setReelsColletion(updatedReelsCollection);
      }
    } catch (error) {
      if (error.response.status === 429) {
        appContext.updateNotificationState({
          show: true,
          message: errorResponseMessage(error),
          type: "error",
        });
        authContext.logout();
      }
      if (error.response.status === 400) {
        appContext.updateNotificationState({
          show: true,
          message: errorResponseMessage(error),
          type: "error",
        });
      }
      if (error.response?.status >= 500) {
        appContext.updateNotificationState({
          show: true,
          message: "Something went wrong, please try again later.",
          type: "error",
        });
      }
      //handle error
    }
  };

  const retweetHandler = async (id) => {
    try {
      const retweetPost = await axiosHttp.post(`/post/${id}/share`);
      if (retweetPost.status === 201) {
        let isDelete = true;
        setReelsColletion([]);
        appContext.updateNotificationState({
          show: true,
          message: "Repost successful",
          type: "success",
        });
        window.scrollTo(0, 0);
        fetchReels(1);
      }
    } catch (e) {
      if (e.response.status === 429) {
        appContext.updateNotificationState({
          show: true,
          message: errorResponseMessage(e),
          type: "error",
        });
        logout();
      }
      if (e.response.status === 400) {
        appContext.updateNotificationState({
          show: true,
          message: errorResponseMessage(e),
          type: "error",
        });
      }
      if (e.response?.status >= 500) {
        appContext.updateNotificationState({
          show: true,
          message: "Something went wrong, please try again later.",
          type: "error",
        });
      }
      //console.log(e);
      setLoading(false);
    }
  };

  const bookHandler = async (id) => {
    try {
      const bookPostResponse = await axiosHttp.post(`post/${id}/bookmark`);
      if (bookPostResponse.status === 201) {
        const updatedReelsCollection = reelsCollection.map((reel) => {
          if (reel.id === id) {
            return {
              ...reel,
              isBookmark:
                reel.isBookmark === "Not" || reel.isBookmark === "No"
                  ? "Yes"
                  : "Not",
            };
          }
          return reel;
        });

        setReelsColletion(updatedReelsCollection);
      }
    } catch (error) {
      if (error.response.status === 429) {
        appContext.updateNotificationState({
          show: true,
          message: errorResponseMessage(error),
          type: "error",
        });
        authContext.logout();
      }
      if (error.response.status === 400) {
        appContext.updateNotificationState({
          show: true,
          message: errorResponseMessage(error),
          type: "error",
        });
      }
      if (error.response?.status >= 500) {
        appContext.updateNotificationState({
          show: true,
          message: "Something went wrong, please try again later.",
          type: "error",
        });
      }
    }
  };

  useEffect(() => {
    // dispatch(getReels());
    dispatch(getActiveNotificationCount());
    dispatch(getActiveChatNotificationCount());
  }, []);

  // useEffect(() => {
  //   setReelsColletion(reels);
  // }, [reels]);

  // useEffect(() => {
  //   dispatch(getReels());
  // }, [appContext.notification]);

  const fetchReels = async (page) => {
    try {
      const getReels = await axiosHttp.get(
        appContext.category === ""
          ? `following-user-posts?page=${page}&type=reels`
          : `following-user-posts?page=${page}&skillCategoryId=${appContext.category}&type=reels`
      );
      if (getReels.status === 200) {
        let data = getReels?.data?.data;
        if (page === 1) {
          setReelsColletion(data);
        } else {
          setReelsColletion([...reelsCollection, ...data]);
        }
        setPage(page + 1);
        setLoading(false);
      }
    } catch (error) {
      if (error.response.status === 429) {
        appContext.updateNotificationState({
          show: true,
          message: errorResponseMessage(error),
          type: "error",
        });
        authContext.logout();
      }
      if (error.response.status === 422) {
        setLoading(false);
      }
      if (error.response.status === 400) {
        appContext.updateNotificationState({
          show: true,
          message: errorResponseMessage(error),
          type: "error",
        });
        setLoading(false);
      }
      if (error.response?.status >= 500) {
        appContext.updateNotificationState({
          show: true,
          message: "Something went wrong, please try again later.",
          type: "error",
        });
        setLoading(false);
      }
    }
  };

  return loading ? (
    <Loader />
  ) : (
    <>
      <div className="card card-one-1">
        <div className="card-body">
          <div className="row">
            <div className="col-md-9 title">Videos</div>
            {/* <div className="col-md-3">
            <button
              className="btn btn-primary btn-reel" 
              onClick={() =>
                appContext.updateModalType("addReels", "Add Reels")
              }
            >
              Add Reels
            </button>
          </div> */}
          </div>
          {reelsCollection.map((item, index) => {
            return (
              <ReelsVideoWrapper
                likeHander={likeHander}
                reelsData={item}
                key={index}
                bookHandler={bookHandler}
                retweetHandler={retweetHandler}
              />
            );
          })}
          {!reelsCollection.length && <NoDataAvailable />}
        </div>
      </div>
    </>
  );
};

export default Reels;
